import NovaventaTextAreaCss from "./NovaventaTextAreaCss";

export const NovaventaTextArea = (props: any) => {
  const {
    placeholder,
    disabled = false,
    id = "",
    maxLength = 10,
    value,
    onChange
  } = props;

  return (
    <NovaventaTextAreaCss
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      disabled={disabled}
      id={id}
      data-testid={id}
      maxLength={maxLength}
    />
  );
};
